import { render, staticRenderFns } from "./InvoiceOrderCard.vue?vue&type=template&id=9b6ca48e&scoped=true"
import script from "./InvoiceOrderCard.vue?vue&type=script&lang=js"
export * from "./InvoiceOrderCard.vue?vue&type=script&lang=js"
import style0 from "./InvoiceOrderCard.vue?vue&type=style&index=0&id=9b6ca48e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6ca48e",
  null
  
)

export default component.exports